import * as PIXI from 'pixi.js'
import _ from 'lodash'
import { easing } from 'popmotion'
import { spriteFromImage, liquidTransition, waveAnimation } from './backgrounds/pixiBindings'

const backgrounds = {
  data: () => ({
    filterImage: require('@/assets/heroBg/clouds.jpg'),
    app: undefined,
    waveTween: undefined,
    liquidEl: undefined
  }),
  props: {
    background: {
      type: String,
      required: true
    },
    animationOptions: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    bgOptions: {
      get () {
        return _.merge(this.defaultOptions, this.animationOptions)
      }
    },
    defaultOptions: {
      get () {
        return {
          backgroundImage: this.background,
          backgroundColor: 296867,
          filterImage: this.filterImage,
          scale: {
            fromX: 3000,
            fromY: 7000,
            toX: 20,
            toY: 20,
            duration: 2000,
            easing: easing.easeOut
          },
          wave: {
            horizontalSpread: 3,
            verticalSpread: 2
          },
          start: true,
          onLoad: this.$_onAnimationLoad
        }
      }
    }
  },
  methods: {
    getApp () {
      return this.app
    },
    $_onAnimationLoad ({ app, waveTween, el }) {
      this.app = app
      this.waveTween = waveTween
      this.liquidEl = el
    }
  },
  directives: {
    'liquid': {
      async bind (el, binding, vnode) {
        renderAnimation(el, binding, vnode)
      },
      update (el, binding, vnode, oldVnode) {
        if (typeof oldVnode.context.$data.waveTween !== 'undefined') oldVnode.context.$data.waveTween.stop()
        oldVnode.context.$data.app.destroy()

        renderAnimation(el, binding, vnode)
      }
    }
  }
}

const renderAnimation = async (el, binding, vnode) => {
  // extract options
  const {
    backgroundImage,
    backgroundColor,
    filterImage,
    scale,
    wave,
    start,
    onLoad
  } = binding.value

  // base texture
  const backgroundSprite = await spriteFromImage(backgroundImage)

  // filter
  const filterSprite = await spriteFromImage(filterImage)
  filterSprite.texture.baseTexture.wrapMode = PIXI.WRAP_MODES.REPEAT
  const displacementFilter = new PIXI.filters.DisplacementFilter(filterSprite)

  // init filter
  displacementFilter.scale.x = scale.fromX
  displacementFilter.scale.y = scale.fromY

  // PIXI app
  const app = new PIXI.Application({
    width: backgroundSprite.width,
    height: backgroundSprite.height,
    resolution: window.devicePixelRatio
  })

  // back color
  app.renderer.backgroundColor = backgroundColor

  // save app
  vnode.context.$data.app = app

  // fill dom
  app.stage.filters = [displacementFilter]
  app.stage.addChild(backgroundSprite)
  app.stage.addChild(filterSprite)

  // append render to element
  el.appendChild(app.view)

  if (start) app.start()

  // Liquid Transition on Enter
  await liquidTransition(displacementFilter, scale)

  // Wave animation
  const waveTween = waveAnimation(filterSprite, wave)

  onLoad({
    app,
    waveTween,
    el
  })
}

export default backgrounds
